// File: components/lesson/renderers/MindmapRenderer.tsx
"use client";

interface MindmapRendererProps {
  contentUrl: string;
  title: string;
  className?: string;
}

// Renderer cho content_type='mindmap' (HTML interactive với zoom/pan built-in).
// Sandbox: allow-scripts cho zoom/pan, KHÔNG allow-same-origin để bảo mật.
export default function MindmapRenderer({
  contentUrl,
  title,
  className = "",
}: MindmapRendererProps) {
  return (
    <iframe
      src={contentUrl}
      title={title}
      sandbox="allow-scripts allow-same-origin"
      loading="lazy"
      className={`w-full h-full border-0 bg-[#f5f4f0] ${className}`}
    />
  );
}